import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toggleCheckbox } from "../../../../../redux/CheckboxSlice";
import { deleteWorklog } from "../../../../../services/apiWorklog";
import useMutate from "../../../../../hooks/useMutate";

export function useWorklogItemState({ cardId, worklogId }) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const checked = useSelector((state) =>
    state.checkbox.checkedIds.includes(worklogId)
  );

  const handleClose = useCallback(() => {
    setShowDelete(false);
  }, []);

  const { mutate: deleteWorklogMutate } = useMutate(
    deleteWorklog,
    [
      ["worklog", cardId],
      ["history", String(cardId)],
      ["worklogHistory"],
      ["boardWorklogs"],
      ["card", cardId],
    ],
    () => {},
    () => {
      setLoading(false);
      handleClose();
    },
    () => {
      setLoading(false);
      handleClose();
    }
  );

  const handleCheckboxChange = useCallback(() => {
    dispatch(toggleCheckbox(worklogId));
  }, [dispatch, worklogId]);

  const handleEdit = useCallback(() => {
    setShowEdit(true);
  }, []);

  const handleDelete = useCallback(() => {
    setShowDelete(true);
  }, []);

  const handleDeleteConfirm = useCallback(() => {
    setLoading(true);
    deleteWorklogMutate(worklogId);
  }, [deleteWorklogMutate, worklogId]);

  return {
    anchorEl,
    checked,
    handleCheckboxChange,
    handleClose,
    handleDelete,
    handleDeleteConfirm,
    handleEdit,
    loading,
    openMenu: Boolean(anchorEl),
    setAnchorEl,
    setShowEdit,
    showDelete,
    showEdit,
  };
}
